module.exports = __webpack_public_path__ + "media/scholarships/icon-office365-2515acaf.svg";